import type {PaymentCard as PaymentDetailsState} from '@logistics-frontend/bound-card/src/shared/types'

import type {EstimateDeliveryWidgetState} from 'src/widgets/EstimateDelivery'

import {DeliveryInterval} from './delivery-interval'
import {DeliveryType} from './delivery-type'
import {DestinationPoint} from './destination-point'
import {FormSettings} from './form-settings'
import {Offer} from './offer'
import {PaymentInfoDetails as PaymentInfoState} from './payment-info-details'
import {ReturnPoint} from './return-point'
import {SourcePoint} from './source-point'
import {Tariff} from './tariff'
import {VerticalTariff} from './vertical'

type OrderWithId = {
  // идентификатор заказа
  id?: string
}

type OrderWithVersion = {
  // Версия ордера. Можно переоценивать заявку миллион раз подряд. Главное - обновлять версию
  version?: number
}

type OrderWithPrice = {
  // Цена заказа
  price?: string
}

type OrderWithDeliveryIntervals = {
  // дата доставки
  deliveryDate?: string
  // интервал доставки по времени
  deliveryInterval?: DeliveryInterval
  // Маппинг интервалов доставки
  __deliveryIntervalsMap?: Record<string, DeliveryInterval[]>
  // Сырые данные интервалов
  __deliveryIntervalsRaw: Array<DeliveryInterval>
}

export const enum NddPaymentType {
  Delivery = 'delivery',
  Goods = 'goods',
}

export const enum PaymentOnDemandType {
  Card = 'card',
  Cash = 'cash',
}

type SddOrder = OrderWithId & OrderWithVersion & OrderWithDeliveryIntervals & OrderWithPrice

type ExpressOrder = OrderWithId &
  OrderWithVersion &
  OrderWithPrice &
  Partial<{
    tariff: Tariff
  }>

type NewTariffLineOrder = OrderWithId &
  OrderWithVersion &
  OrderWithPrice &
  Partial<{
    // Выбранное направление доставки (По городу или по России)
    deliveryDirection: string
    // Выбранный тип доставки (Сейчас или ко времени)
    deliveryType: 'now' | 'toTime'
    // Выбранная вертикаль, которая будет использоваться для расчета доставки. Раньше это были тарифы
    vertical: VerticalTariff
    // Дата доставки
    deliveryDate?: string
    // Время доставки
    deliveryTime?: string
    // Интервал доставки
    deliveryInterval?: DeliveryInterval
    offer: Offer
  }>

export type Order = {
  // Выбран ли способ заказа как заказ бизнеса
  isBusiness: boolean
  // идентификатор предложения (из блока предложений доставки)
  offerId?: string
  // выбранное направление доставки (По городу или по России)
  selectedDeliveryDirection?: string
  // Старые типы доставки. Сейчас их может быть сколько угодно
  deliveryType: DeliveryType
  // точка откуда (Откуда будет отправлен заказ)
  sourcePoint: SourcePoint
  // точка куда (Куда будет доставлен заказ)
  destinationPoints: Array<DestinationPoint>
  // точка возврата (Куда будет доставлен заказ)
  returnPoint?: ReturnPoint
  // Застрахована ли посылка
  isParcelInsured: boolean
  // Подтвердить кодом на точке возврата
  isReturnPointCodeConfirmation: boolean
  // Возврат товара возможен
  isOptionalReturn: boolean
  // Отправить получателю ссылку на отслеживание
  isNotifyClient: boolean
  // Заказать ко времени (бывшее св-во due)
  orderTime?: {
    _date?: string
    _time?: number
    date?: string
  }
  express: ExpressOrder
  sdd: SddOrder
  ndd: OrderWithDeliveryIntervals
  nddOrder: EstimateDeliveryWidgetState
  offerFlow: NewTariffLineOrder
  comment?: string
  /**
   * Информация о методах оплаты пользователя
   */
  paymentInfo?: PaymentInfoState
  /**
   * Информация о выбранном методе оплаты
   */
  paymentMethod?: PaymentDetailsState
  __settings: FormSettings
}
